import React from 'react';
import _ from 'lodash';

import {
  AuditLogWidgetDocument,
  useSaveAuditLogEventMutation
} from 'generated/graphql';

import * as types from './types';



export function useSaveAuditLogEvent({
  orderId, returnAuthorizationId, sendsEmail
}: {
  orderId?: string;
  returnAuthorizationId?: string;
  sendsEmail: boolean;
}) {
  const [fnQuery, tuple] = useSaveAuditLogEventMutation({
    refetchQueries: orderId ? [
      {
        query: AuditLogWidgetDocument,
        variables: {
          id: orderId ?? returnAuthorizationId,
          isQueryingOrder: !_.isNil(orderId)
        }
      }
    ] : []
  });

  const fnWrappedMutate = React.useCallback(async (formData: types.IFormState) => {
    await fnQuery({
      variables: {
        input: {
          title: formData.title,
          content: formData.content,
          orderId,
          returnAuthorizationId,
          sendsEmail
        }
      }
    });
  }, [
    fnQuery,
    orderId,
    returnAuthorizationId,
    sendsEmail
  ]);

  return React.useMemo(() => [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const, [tuple, fnWrappedMutate]);
}
